import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GroupCustomerRoutingModule } from './group-customer-routing.module';
import { GroupCustomerComponent } from './group-customer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/core/material';
import { SharedModule } from 'src/app/shared/shared.module';
import { CreateGroupCustomerComponent } from './create-group-customer/create-group-customer.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { UpdateGroupCustomerDialogComponent } from './update-group-customer-dialog/update-group-customer-dialog.component';
import {NgMatAutocompleteModule} from '../../../../../shared/components/autocomplete/autocomplete.module';


@NgModule({
  declarations: [GroupCustomerComponent, CreateGroupCustomerComponent, UpdateGroupCustomerDialogComponent],
  imports: [
    CommonModule,
    GroupCustomerRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    NgZorroAntdModule,
    NgMatAutocompleteModule
  ],
  entryComponents: [
    UpdateGroupCustomerDialogComponent
  ]
})
export class GroupCustomerModule { }
